export default class Form {
    init() {
        this.contactFormMessage = document.querySelector('.js-contact-form-message');

        if (document.querySelector('.js-contact-form-id')) {
            this.contactFormId = document.querySelector('.js-contact-form-id').getAttribute('data-form-id');
        }

        this.onMailSent();
    }

    onMailSent() {
        document.addEventListener('wpcf7mailsent', (event) => {

            if (this.contactFormId === event.detail.contactFormId) {
                this.contactFormEvents();
            }
        });
    }

    contactFormEvents() {
        this.contactFormMessage.style.display = 'block';

        setTimeout(() => {
            this.contactFormMessage.style.display = 'none';
        }, 8000);
    }

    setCookie(name, value, days) {
        let expires = "";

        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }

        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
}
